import { FireAndFlowerCardData } from './fire-and-flower-card-data';

export class FireAndFlowerOldStyleCardData extends FireAndFlowerCardData {
  readonly showRegularPriceAtBottom: boolean;
}
